import * as msal from '@azure/msal-browser';
import { msalConfig } from './config';

export const msalInstance = new msal.PublicClientApplication(msalConfig);
await msalInstance.initialize();

const accounts = msalInstance.getAllAccounts();
if (accounts.length > 0) {
	msalInstance.setActiveAccount(accounts[0]);
}

msalInstance.addEventCallback((event: msal.EventMessage) => {
	if (event.eventType === msal.EventType.LOGIN_SUCCESS && event.payload) {
		const payload = event.payload as msal.AuthenticationResult;
		const account = payload.account;
		msalInstance.setActiveAccount(account);
	}
});
